import React from "react";

export default function SelectTailwind({
  placeholder,
  options,
  width,
  register,
  registerName,
}) {
  return (
    <select
      {...register(registerName)}
      className={`block w-${
        width ? width : 52
      } text-gray-700 mr-5 py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 `}
    >
      <option value>{placeholder}</option>
      {options.map((item) => (
        <option value={item}>{item}</option>
      ))}
    </select>
  );
}
